import { Col, Row, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setExprirySetting } from "../../store/slice/expirySettingSlice";
import {
  ExpirySettingRow,
  ExpirySquareOffRow,
  Label,
  NewPositionRow,
} from "./style";
import { SEGMENTS, optionDays, options } from "../../Helper/constant";
import ThemeDropDown from "../../components/ThemeDropDown";
import ThemeCard from "../../components/ThemeCard";
import { useGetScript } from "../../APICall/apiHooks";
import React, { useEffect, useState } from "react";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import ThemeInput from "../../components/ThemeInput";

const canGetScript = (tab) => {
  if (tab === "COMEX" || tab === "MCX" || tab === "MCX OPT") {
    return true;
  } else {
    return false;
  }
};

const NseOptionRender = ({ tab }) => {
  // custom hook for get script list
  const { scriptList, scriptLoading } = useGetScript({
    marketName: canGetScript(tab) ? SEGMENTS[tab] : null,
  });
  const dispatch = useDispatch();

  // redux
  const expiryValue = useSelector((state) => state.expirySettingSlice[tab]);

  // state for MCX tender date
  const [contractExpiry, setContractExpiry] = useState(null);
  const [tenderDateLoading, setTenderDateLoading] = useState(false);

  // Fetch MCX tender date
  const fetchMcxTenderDate = async (symbol) => {
    if (!symbol) {
      setContractExpiry(null);
      return;
    }
    setTenderDateLoading(true);
    try {
      const response = await APICall(
        "get",
        `${EndPoints.getMcxTenderDate}?symbolName=${symbol}-I`
      );
      if (response?.status === 200 && response?.data?.data?.contractExpiry) {
        setContractExpiry(response.data.data.contractExpiry);
      } else {
        setContractExpiry(null);
      }
    } catch (error) {
      console.error("Error fetching MCX tender date:", error);
      setContractExpiry(null);
    } finally {
      setTenderDateLoading(false);
    }
  };

  // function
  const handleChange = (name, selectedValue, selectedOptions) => {
    switch (name) {
      case "SquareOffRate":
        dispatch(
          setExprirySetting({
            key: "SquareOffRate",
            value: selectedValue[0],
            tab: tab,
            parent_key: "intraday",
          })
        );
        break;
      case "rate":
      case "dayBefore":
        dispatch(
          setExprirySetting({
            key: [name],
            value: selectedValue[0],
            tab: tab,
            parent_key: "position",
            nested_key: "expirySquareOffRateAndDayBefore",
          })
        );
        break;
      case "valanEndingSquareOffRate":
      case "newPositionStartBeforeDay":
        dispatch(
          setExprirySetting({
            key: [name],
            value: selectedValue[0],
            tab: tab,
            parent_key: "position",
          })
        );
        break;
      case "scriptName":
        dispatch(
          setExprirySetting({
            key: [name],
            value: selectedValue[0],
            tab: tab,
          })
        );
       
        break;
    }
  };

  // Fetch tender date when scriptName is already set and tab is MCX
  useEffect(() => {
    if (tab === "MCX" && expiryValue?.scriptName) {
      fetchMcxTenderDate(expiryValue.scriptName);
    } else {
      setContractExpiry(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, expiryValue?.scriptName]);

  return (
    <>
      <Row>
        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
          <ThemeDropDown
            title="Script Name"
            placeholder="Select"
            name="scriptName"
            width={"98%"}
            showSearch={true}
            options={
              tab !== "NSE OPT" ? scriptList : options.user.Expiry.NSE_OPTIONS
            }
            $onChange={handleChange}
            $value={expiryValue?.scriptName}
            suffixIcon={<Spin size="small" spinning={scriptLoading} />}
          />
        </Col>
        {tab === "MCX" && (
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <ThemeInput
              title="Last Trade Date"
              width={"98%"}
              inputProps={{
                value: contractExpiry || "",
                readOnly: true,
                placeholder: "Last Trade Date",
              }}
              extraProps={{
                addonAfter: tenderDateLoading ? (
                  <Spin size="small" />
                ) : null,
              }}
            />
          </Col>
        )}
      </Row>
      <ThemeCard
        title="INTRADAY"
        bordered={false}
        style={{ marginTop: "1rem" }}
      >
        <ExpirySettingRow>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Label>Intraday Square-Off Rate</Label>
          </Col>
          <Col xs={24} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Quotation Rate"
              name="SquareOffRate"
              width={"98%"}
              options={options.user.Expiry.MCX_OPTION}
              $onChange={handleChange}
              $value={expiryValue.intraday?.SquareOffRate}
            />
          </Col>
        </ExpirySettingRow>
      </ThemeCard>
      <ThemeCard
        title="POSITION"
        bordered={false}
        style={{ marginTop: "2rem" }}
      >
        <ExpirySquareOffRow gutter={[10, 10]}>
          <Col xs={24} sm={24} md={12} lg={10} xl={6}>
            <Label>Expiry Square-Off Rate And Day Before</Label>
          </Col>
          <Col xs={12} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Quotation Rate"
              name="rate"
              width={"98%"}
              options={options.user.Expiry.MCX_OPTION}
              $onChange={handleChange}
              $value={
                expiryValue.position?.expirySquareOffRateAndDayBefore?.rate
              }
            />
          </Col>
          <Col xs={12} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Select Days"
              name="dayBefore"
              width={"98%"}
              options={optionDays.slice(0, 31)}
              $onChange={handleChange}
              $value={
                expiryValue.position?.expirySquareOffRateAndDayBefore?.dayBefore
              }
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={10} xl={5}>
            <Label>Valan Ending Square-Off Rate </Label>
          </Col>
          <Col xs={24} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Closing Rate"
              name="valanEndingSquareOffRate"
              width={"98%"}
              options={options.user.Expiry.MCX_OPTION}
              $onChange={handleChange}
              $value={expiryValue.position?.valanEndingSquareOffRate}
            />
          </Col>
        </ExpirySquareOffRow>
        <NewPositionRow>
          <Col xs={24} sm={24} md={12} lg={10} xl={6}>
            <Label>New Position Start Before Day</Label>
          </Col>
          <Col xs={24} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Select Days"
              name="newPositionStartBeforeDay"
              width={"98%"}
              options={optionDays.slice(0, 31)}
              $onChange={handleChange}
              $value={expiryValue.position?.newPositionStartBeforeDay}
            />
          </Col>
        </NewPositionRow>
      </ThemeCard>
    </>
  );
};

export default React.memo(NseOptionRender);
